import React from 'react';
import { ArrowRight, HandHeart, Building2, Briefcase, Megaphone } from 'lucide-react';
import { waysToStand } from '../mock';

const iconMap = { HandHeart, Building2, Briefcase, Megaphone };

const tones = {
  aqua: { bg: '#79c4c7', soft: '#F0F8F8', text: '#4F969A' },
  purple: { bg: '#6e12ed', soft: '#F3EBFE', text: '#4E0BB0' },
};

const WaysToStand = () => {
  return (
    <section id="take-part" className="py-24 lg:py-32 bg-[#F7F7F8] relative overflow-hidden">
      <div className="brush-swash w-96 h-20 top-32 -right-16" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="max-w-3xl mb-16">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-neutral-500 mb-4">
            How you can take part
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-[#0E1112] leading-[1.05]">
            Four ways to <span className="hl-box hl-purple">stand</span><br />
            with our community.
          </h2>
          <p className="mt-5 text-neutral-700 text-lg leading-relaxed">
            Every conversation, every pound and every hour makes holistic mental health care
            possible for someone in the Black Country — and inspires change beyond it.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {waysToStand.map((w) => {
            const Icon = iconMap[w.icon];
            const t = tones[w.accent];
            return (
              <article
                key={w.id}
                className="group bg-white rounded-[1.75rem] overflow-hidden border border-black/5 hover:shadow-2xl transition-all duration-500"
              >
                <div className="grid sm:grid-cols-5">
                  <div className="sm:col-span-2 relative overflow-hidden card-image-zoom min-h-[240px]">
                    <img
                      src={w.image}
                      alt={w.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute top-4 left-4">
                      <span
                        className="inline-block rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white"
                        style={{ backgroundColor: t.bg }}
                      >
                        {w.tag}
                      </span>
                    </div>
                  </div>
                  <div className="sm:col-span-3 p-7 lg:p-9 flex flex-col">
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                      style={{ backgroundColor: t.soft }}
                    >
                      <Icon className="w-5 h-5" style={{ color: t.bg }} />
                    </div>
                    <h3 className="font-serif text-2xl lg:text-[28px] font-bold text-[#0E1112] leading-tight">
                      {w.title}
                    </h3>
                    <p className="text-sm font-semibold mt-1" style={{ color: t.text }}>
                      {w.subtitle}
                    </p>
                    <p className="mt-3 text-neutral-600 leading-relaxed text-sm flex-1">{w.description}</p>
                    <a
                      href={w.id === 'donate' ? '#donate' : '#'}
                      className="mt-6 self-start inline-flex items-center gap-2 font-semibold text-white rounded-md h-11 px-5 transition-transform hover:translate-y-[-1px]"
                      style={{ backgroundColor: t.bg }}
                    >
                      {w.cta}
                      <ArrowRight className="w-4 h-4" />
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WaysToStand;
